var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 1.33334C7.89999 1.33334 1.3335 7.89983 1.3335 16C1.3335 24.1002 7.89999 30.6667 16.0002 30.6667C24.1003 30.6667 30.6668 24.1002 30.6668 16C30.6668 7.89983 24.1003 1.33334 16.0002 1.33334ZM14.0002 12C14.0002 11.2636 13.4032 10.6667 12.6668 10.6667C11.9304 10.6667 11.3335 11.2636 11.3335 12V20C11.3335 20.7364 11.9304 21.3333 12.6668 21.3333C13.4032 21.3333 14.0002 20.7364 14.0002 20V12ZM20.6668 12C20.6668 11.2636 20.0699 10.6667 19.3335 10.6667C18.5971 10.6667 18.0002 11.2636 18.0002 12V20C18.0002 20.7364 18.5971 21.3333 19.3335 21.3333C20.0699 21.3333 20.6668 20.7364 20.6668 20V12Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopBlack);
export default __webpack_public_path__ + "static/media/stopBlack.e49552775bf34f7cae0a4d9d3b2adb40.svg";
export { ForwardRef as ReactComponent };